import { useTranslation } from "react-i18next";
import { TabContext, TabPanel } from "@mui/lab";
import { Box, Stack, Tab } from "@mui/material";

import { Tabs, useTabValue } from "common/components/Tabs/Tabs";
import { OrganizationApiToken } from "types/Organization";
import { OverviewTab } from "./OverviewTab";
import { PermissionsTab } from "./PermissionsTab";
import { SettingsTab } from "./SettingsTab";

interface SelectedTokenPanelProps {
  token: OrganizationApiToken;
}

export const SelectedTokenPanel = ({
  token,
}: SelectedTokenPanelProps): JSX.Element => {
  const { t } = useTranslation();
  const [tabsValue, setTabsValue] = useTabValue<
    "Overview" | "Permissions" | "Settings"
  >("Overview");

  return (
    <Stack
      sx={{
        pr: 2,
        width: "100%",
        maxHeight: "100%",
        height: "100%",
      }}
    >
      <TabContext value={tabsValue}>
        <Tabs onChange={setTabsValue}>
          <Tab label={t("Overview")} value={"Overview"} />
          <Tab label={t("Permissions")} value={"Permissions"} />
          <Tab label={t("Settings")} value={"Settings"} />
        </Tabs>
        <Box
          sx={{
            flexDirection: "column",
            display: "flex",
            flex: 1,
            ...(tabsValue !== "Settings" && { overflow: "hidden" }),
          }}
        >
          <TabPanel value="Overview">
            <OverviewTab token={token} />
          </TabPanel>
          <TabPanel value="Permissions">
            <PermissionsTab token={token} />
          </TabPanel>
          <TabPanel value="Settings">
            <SettingsTab token={token} />
          </TabPanel>
        </Box>
      </TabContext>
    </Stack>
  );
};
